import { render, staticRenderFns } from "./DaftarGadai.vue?vue&type=template&id=1151d388&scoped=true&"
import script from "./DaftarGadai.vue?vue&type=script&lang=js&"
export * from "./DaftarGadai.vue?vue&type=script&lang=js&"
import style0 from "./DaftarGadai.vue?vue&type=style&index=0&id=1151d388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1151d388",
  null
  
)

export default component.exports